import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { prettifyNumber } from "../../lib/prettifier";
import Decimal from "break_infinity.js";

export function OfflineProgressDialog(props: {
  open: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
  diff?: { producers: { name: string; diff: Decimal }[] };
}) {
  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <DialogTitle style={{ color: "#2196f3" }}>
        While you were offline...
      </DialogTitle>
      <DialogContent>
        {props.diff?.producers.map((prod, index) => {
          if (prod.diff.eq(0)) return null;
          return (
            <Typography style={{ color: "white", opacity: 0.8 }} key={index}>
              You earned {prettifyNumber(prod.diff)} {prod.name}s
            </Typography>
          );
        })}
        {isDiffEmpty(props.diff) && (
          <Typography style={{ color: "white", opacity: 0.8 }}>
            Nothing happened
          </Typography>
        )}
        <Typography style={{ color: "white", opacity: 0.8 }}></Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setOpen(false)}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

function isDiffEmpty(
  diff: { producers: { name: string; diff: Decimal }[] } | undefined
) {
  if (!diff) return true;
  return diff.producers.every((prod) => prod.diff.eq(0));
}
